export default __webpack_public_path__ + "static/media/section-process-bg1.acef6cf8.png";